module.exports = __webpack_public_path__ + "img/card-4.88a5b6d0.png";